import logo from './logo.svg';
import './App.css';
import ClientIntakeFormUK from './client_intake_form_uk';

function App() {
  return (
    <ClientIntakeFormUK />
  );
}

export default App;
